// extracted by mini-css-extract-plugin
export default {"scroll-up-button":"styles-module__scroll-up-button___u4XU0","hide":"styles-module__hide___pxR1p"};